import * as React from 'react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'

// localization: translated

interface IProps {
  isShown: boolean
  onHide: () => void
  onApply: () => void
}

export default class EditingConfirm extends React.PureComponent<IProps> {
  public render() {
    const { isShown, onHide, onApply, children } = this.props

    return (
      <ConfirmDialog
        isOpen={isShown}
        title={Localization.translator.editingConfirmation}
        onCancelClicked={onHide}
        onDoneClicked={onApply}
        doneTitle={Localization.translator.confirm}
      >
        <div className="tw:text-body-md tw:text-foreground">{children}</div>
      </ConfirmDialog>
    )
  }
}
